export class FetchEventByIdRequest {

    constructor(public eventId?: number){
    };
}
